import type Activity from '../model/Activity'
import type ActivityLog from '../model/ActivityLog'
import type User from '../model/User'
import DateUtil from '../util/DateUtil'

export interface ActivityFeedItem {
  id: string
  userID: string
  initials: string
  photoUrl?: string
  name: string
  message: string
  time: string
  rms?: number
  isBadge?: boolean
}

export function buildActivityFeed(
  activityLogs: ActivityLog[],
  activities: Activity[],
  members: User[],
): ActivityFeedItem[] {
  const sorted = [...activityLogs].sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())

  return sorted.flatMap((log) => {
    const activity = activities.find((item) => item.id === log.activityID)
    const member = members.find((item) => item.id === log.userID)
    if (!activity || !member) return []

    return {
      id: log.id,
      userID: log.userID,
      initials: `${member.firstName.charAt(0)}${member.lastName?.charAt(0) ?? ''}`.toUpperCase(),
      photoUrl: member.photoUrl,
      name: `${member.firstName} ${member.lastName?.charAt(0) ?? ''}.`.trim(),
      message: `logged ${activity.title.toLowerCase()}`,
      time: DateUtil.getRelativeTimeString(log.createdAt),
      rms: Math.round(log.amount),
    }
  })
}
